import { render, staticRenderFns } from "./areaMany.vue?vue&type=template&id=0c191a5c"
import script from "./areaMany.vue?vue&type=script&lang=js"
export * from "./areaMany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports